import "./App.scss";
import Routes from "./routes/Routes";
import { Provider } from "react-redux";
import configureStore from 'store/configureStore';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import BrandThemeProvider from "contexts/ThemeContext";

export const { store } = configureStore();
if (process.env.NODE_ENV === "prod") {
  console.log = () => { };
}

function App() {
  const isScrollableDashboardRoute =
    typeof window !== "undefined" &&
    (/\/(pepe|enamor)-funnel-dashboard/.test(window.location.pathname) ||
      /\/(barenecessities|jockey|jockeydemo|cosabella|bare)\//.test(window.location.pathname) ||
      /^\/bare\//.test(window.location.pathname) ||
      /^\/jockey\/dashboard/.test(window.location.pathname));

  return (
    <div className={`App ${isScrollableDashboardRoute ? "App--scrollable" : ""}`}>
        <BrandThemeProvider>
          <Provider store={store}>
            <Routes />
          </Provider>
        </BrandThemeProvider>
    </div >
  );
}

export default App;
